import { ClickAwayListener, IconButton } from '@mui/material';
import { Search } from 'lucide-react';

import { GlobalSearchBox } from '../search/index.js';

interface Props {
    shown: boolean;
    onHide: () => any;
}

const HeaderSearchBox: FC<Props> = ({ shown, onHide }) => {
    const onClickAway = (evt) => {
        if (shown && !evt.target.closest('.global-search-results')) {
            onHide();
        }
    };

    return (
        <div className={`header-search-box ${shown ? 'shown' : ''}`}>
            <IconButton className="search-button" onClick={onHide}>
                <Search className="search-icon" />
            </IconButton>
            <ClickAwayListener onClickAway={onClickAway}>
                <div className="search-container">
                    <GlobalSearchBox />
                </div>
            </ClickAwayListener>
        </div>
    );
};

export default HeaderSearchBox;
